// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/loans/received-loans/repaid',
        component: () =>
            import('@/pages/[organisation]/loans/received-loans/repaid.vue'),
        name: 'loans.received-loan.repaid-received-loans',
        meta: {
            loginRequired: true,
            permission: 'access.finance.loans.received-loan.update-draft-received-loan',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/loans/received-loans/repaid/[id].vue'),
                name: 'loans.received-loan.view-repaid-received-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.received-loan.update-draft-received-loan',
                },
            },
        ],
    },

    {
        path: '/:organisation/loans/received-loans',
        component: () =>
            import('@/pages/[organisation]/loans/received-loans.vue'),
        name: 'loans.received-loan.search-received-loans',
        meta: {
            loginRequired: true,
            permission: 'access.finance.loans.received-loan.view-received-loans',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/loans/received-loans/new.vue'),
                name: 'loans.received-loan.create-received-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.received-loan.create-received-loan',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "loans.received-loan" */ '@/pages/[organisation]/loans/received-loan/received-loan/[id].vue'),
                name: 'loans.received-loan.view-received-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.received-loan.view-received-loans',
                },
                children: [
                    {
                        path: 'record-payment',
                        component: () =>
                            import(/* webpackChunkName: "loans.received-loan" */ '@/pages/[organisation]/loans/received-loan-payment/received-loan-payment/new.vue'),
                        name: 'loans.received-loan-payments.create-received-loan-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.loans.received-loan-payment.create-received-loan-payment',
                        },
                    },
                ],
            },
            {
                path: ':id/edit',
                component: () =>
                    import(/* webpackChunkName: "loans.received-loan" */ '@/pages/[organisation]/loans/received-loan/received-loan/[id]/edit.vue'),
                name: 'loans.received-loan.update-received-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.received-loan.update-draft-received-loan',
                },
            },
            {
                path: ':id/loan-payments',
                component: () =>
                    import(/* webpackChunkName: "loans.received-loan" */ '@/pages/[organisation]/loans/received-loan-payment/received-loan-payments.vue'),
                name: 'loans.received-loan-payments.search-received-loan-payments',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.received-loan-payment.view-received-loan-payments',
                },
                children: [
                    {
                        path: ':paymentId/redo-payment',
                        component: () =>
                            import(/* webpackChunkName: "loan.received-loan" */ '@/pages/[organisation]/loans/received-loan-payment/redo-received-loan-payment.vue'),
                        name: 'loans.received-loan-payments.redo-received-loan-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.loans.received-loan-payment.redo-received-loan-payment',
                        },
                    },
                ],
            },
        ],
    },
];
